import { useCallback } from 'react';
import { useSearchParams } from 'next/navigation';

import {
  getClientSearchParams,
  syncListingSearchParams,
} from '../utils/listingSearchParams';

const useUpdateSearchParams = () => {
  const searchParams = useSearchParams();

  const createQueryString = useCallback(
    (updates: Record<string, string[] | string | null>) => {
      const params = getClientSearchParams(searchParams.toString());

      Object.entries(updates).forEach(([name, value]) => {
        if (value === null || value === undefined) {
          params.delete(name);
        } else if (Array.isArray(value)) {
          if (value.length > 0) {
            params.set(name, value.join(','));
          } else {
            params.delete(name);
          }
        } else if (value) {
          params.set(name, value);
        } else {
          params.delete(name);
        }
      });

      return params.toString();
    },
    [searchParams],
  );

  const updateSearchParams = (
    params: Record<string, string[] | string | null>,
  ) => {
    const queryString = createQueryString(params);
    syncListingSearchParams(queryString);
  };

  const clearSearchParams = () => {
    syncListingSearchParams('');
  };

  return { updateSearchParams, clearSearchParams };
};

export { useUpdateSearchParams };
